var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LogsList',{attrs:{"items":_vm.items,"pagination-data":_vm.paginationData},on:{"pageChange":_vm.getData}})
}
var staticRenderFns = []

export { render, staticRenderFns }